import { AuthenticationContext } from 'components/templates/AuthenticationProvider/AuthenticationProvider';
import { useRouter } from 'next/router';
import { useContext, useState } from 'react';
import { graphql, useMutation } from 'react-relay';
import { PayloadError } from 'relay-runtime';
import {
  useCloseAccountMutation,
  useCloseAccountMutation$data,
} from './__generated__/useCloseAccountMutation.graphql';

const closeAccountMutation = graphql`
  mutation useCloseAccountMutation($input: CloseAccountInput!) {
    closeAccount(input: $input)
  }
`;

export function useCloseAccount() {
  const [commitCloseAccount, closeAccountIsInFlight] =
    useMutation<useCloseAccountMutation>(closeAccountMutation);
  const { logOut } = useContext(AuthenticationContext);
  const router = useRouter();
  const [error, setError] = useState<string | undefined>(undefined);

  function closeAccount() {
    commitCloseAccount({
      variables: {
        input: {
          reason: 'OTHER',
          retainData: true,
        },
      },
      onError: (err) => {
        console.error(err);
        setError(err.message);
      },
      onCompleted: (_: useCloseAccountMutation$data, errors: PayloadError[] | null) => {
        if (!errors) {
          logOut('cancelAccount');
          router.push('/');
          return;
        }
        console.error(errors);
        setError(errors[0].message);
      },
    });
  }

  return { closeAccount, closeAccountIsInFlight, error, setError };
}
